<template>
    <section
        class="bg-black-700 full-width relative h-auto flex flex-col relative">
        <!--Image Background-->
        <background-image
            :src="sectionBenefits.src"
            :srcset="sectionBenefits.imgSrcSet" />

        <!--Content Layout in a Container-->
        <div
            class="container flex flex-col z-10 h-full mt-24 mb-10 tabletLandscape:flex-grow tabletLandscape:justify-end desktop:mb-18">
            <!-- Div 1 - Text Aside spacer and Text Component with button-->
            <div class="desktop:flex">
                <!--Layout Spacer -- Matches Aside Text Component sizing/spacing-->
                <div class="hidden tablet:flex w-1/4 max-w-xxs mr-10 desktop:mr-32 hd:w-0 hd:mr-0"></div>

                <!--Content Block  -->
                <div
                    class="section-text-with-button flex flex-col items-start tabletLandscape:max-w-lg desktop:max-w-md hd:max-w-xl">
                    <!--Content Text Component-->
                    <content-text>
                        <template #title-text>
                            <h2
                                class="font-regular"
                                v-html="sectionBenefits.title"></h2>
                        </template>
                        <template #content-text>
                            <div
                                class="font-regular mb-6"
                                v-html="sectionBenefits.content">
                            </div>
                        </template>
                    </content-text>

                    <!-- CTA button -->
                    <!--<tis-button class="btn-flat block text-sm">-->
                    <!--{{sectionBenefits.buttonText}}-->
                    <!--<svg-icon icon="arrow-horizontal" class="w-6 h-6 inline-block ml-2"/>-->
                    <!--</tis-button>-->
                </div>
            </div>

            <!-- Div 2 - Icon components layout -->
            <div
                class="flex flex-wrap mt-16 tabletLandscape:mt-0 max-w-xl tabletLandscape:max-w-sm hd:max-w-lg tabletLandscape:absolute tabletLandscape:right-0">
                <div
                    v-for="(benefit, index) in sectionBenefits.benefits"
                    :key="index"
                    class="icon-component w-20 tablet:w-28 desktop:w-35 mr-4 tablet:mr-8 desktop:mr-12 hd:mr-16 mb-8">
                    <svg-icon
                        :icon="benefit.icon"
                        :class="classes.iconComponent.icon" />
                    <hr :class="classes.iconComponent.hr">
                    <p :class="classes.iconComponent.iconText">
                        {{ benefit.iconText }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ContentText from '@web/components/ContentText';
import BackgroundImage from '@web/components/BackgroundImage';
import SvgIcon from '@whisper/components/icons/SvgIcon';

export default {
  components: {
    SvgIcon,
    ContentText,
    BackgroundImage,
  },
  props: {
    sectionBenefits: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    classes: {
      iconComponent: {
        hr: [
          'text-gold-500',
          'w-16',
          'tablet:w-24',
          'hd:w-40',
          'mt-3',
          'mb-2',
          'desktop:w-32',
          'desktop:mt-6',
          'desktop:mb-5',
          'hd:mt-8',
          'hd:mb-6',
        ],
        icon: [
          'h-10',
          'tablet:h-14',
          'desktop:h-16',
          'hd:h-20',
          'text-white',
        ],
        iconText: [
          'uppercase',
          'text-white',
          'font-regular',
          'mobile:text-sm',
          'desktop:text-lg',
        ],
      },
    },
  }),
};
</script>

<style scoped lang="scss">

</style>
